export default __webpack_public_path__ + "static/media/hl3.4e94f63f.png";